$(document).on("turbo:load", function () {
  FontAwesome.dom.i2svg();
  FontAwesome.dom.watch();
});
